export function characterTokenData(shape) {
  if (shape.type !== 'character') return {};
  const { placeableType, placeableId, sizeFeet, gridColumn, gridRow, avatarUrl, directionDegrees = 0 } = shape;
  return { placeableType, placeableId, sizeFeet, gridColumn, gridRow, avatarUrl, directionDegrees };
}

export function characterTokenGeometry(token, grid) {
  if (
    !Number.isFinite(token.sizeFeet) ||
    token.sizeFeet < 5 ||
    !Number.isInteger(token.gridColumn) ||
    !Number.isInteger(token.gridRow) ||
    !Number.isFinite(grid.size) ||
    grid.size <= 0
  )
    return null;
  const diameter = (token.sizeFeet / 5) * grid.size;
  return {
    x: grid.offsetX + token.gridColumn * grid.size,
    y: grid.offsetY + token.gridRow * grid.size,
    width: diameter,
    height: diameter
  };
}

export function characterTokenAtPointer(point, token, grid) {
  if (!point || !Number.isFinite(grid.size) || grid.size <= 0) return null;
  return {
    ...token,
    gridColumn: Math.floor((point.x - grid.offsetX) / grid.size),
    gridRow: Math.floor((point.y - grid.offsetY) / grid.size)
  };
}
